import { Color, SectionMessage, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const PaymentSection = styled(SectionMessage)`
  align-items: center;
  min-height: 46px;
  padding: ${Spacing.S2} ${Spacing.S16};
  border: 1px solid ${Color.Grey150};
  background-color: ${Color.Grey100};
`
